import type { ChatRequestErrorContext } from "@metalmind-ab/mmagent-chat-ui";

export const CHAT_FETCH_BLOCKED_MESSAGE =
  "X-Machine could not send this message. It may be a network problem. Your message is kept; please check your connection and try again.";

export const CHAT_FETCH_INVALID_REQUEST_MESSAGE =
  "X-Machine could not send this message because of a problem in the app, not your connection. Your message is kept. We have been notified.";

export type ChatFetchErrorKind = "invalid_request" | "network";

export function classifyChatFetchError(error: Error): ChatFetchErrorKind {
  return error.message.startsWith("Failed to execute 'fetch'")
    ? "invalid_request"
    : "network";
}

export function getChatFetchFailureMessage(kind: ChatFetchErrorKind): string {
  return kind === "invalid_request"
    ? CHAT_FETCH_INVALID_REQUEST_MESSAGE
    : CHAT_FETCH_BLOCKED_MESSAGE;
}

export function getChatFetchFailureKind(
  error: Error,
  context?: ChatRequestErrorContext,
): ChatFetchErrorKind | undefined {
  if (
    error.name !== "TypeError" ||
    context?.kind !== "chat_post" ||
    context.phase !== "fetch_rejected"
  ) {
    return undefined;
  }
  return classifyChatFetchError(error);
}
